import {backAdmin} from "../axios";

export const usersApi = [
    {url: `${backAdmin}/admins`, name: 'admins.all', method: 'GET'},
    {url: `${backAdmin}/admins/roles`, name: 'admins.roles.all', method: 'GET'},
    {url: `${backAdmin}/admins/countries`, name: 'admins.countries.all', method: 'GET'},
    {url: `${backAdmin}/admins/{id}/role`, name: 'admin.update.role', method: 'PUT'},
    {url: `${backAdmin}/admins/{id}`, name: 'admin.delete', method: 'DELETE'},
    {url: `${backAdmin}/admins`, name: 'admin.create', method: 'POST'},
    {url: `${backAdmin}/admins/{id}`, name: 'admin.update', method: 'PUT'},
    {url: `${backAdmin}/admins/{id}/wallet`, name: 'admin.wallets', method: 'GET'},
    {url: `${backAdmin}/admins/{id}/wallet/update`, name: 'admin.wallets.update', method: 'PUT'},
]